import { render, staticRenderFns } from "./FeatureContainer.vue?vue&type=template&id=b0e384d0&scoped=true"
import script from "./FeatureContainer.vue?vue&type=script&lang=ts"
export * from "./FeatureContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e384d0",
  null
  
)

export default component.exports